const defaultFontSize = 16;

/**
 *
 * @param cssValue CSS raw value as a string, e.g. "1rem", "2em", "20px", "125%"
 * @param currentFontSizePx Current font size in pixels, required for em and % value conversions, defaults to 16.
 * @returns
 */
export const cssValueToPixels = (cssValue: string, currentFontSizePx?: number): number => {
  if (cssValue.endsWith('rem')) {
    const remCandidateVal = parseFloat(cssValue.slice(0, -3));
    const remVal = Number.isFinite(remCandidateVal) && !Number.isNaN(remCandidateVal) ? remCandidateVal : 0;
    // TODO fix use of getComputedStyle so that we scale based on user font size
    return remVal * 16;
  }
  if (cssValue.endsWith('em')) {
    const emCandidateVal = parseFloat(cssValue.slice(0, -2));
    const emVal = Number.isFinite(emCandidateVal) && !Number.isNaN(emCandidateVal) ? emCandidateVal : 0;
    const fontSize =
      currentFontSizePx && Number.isFinite(currentFontSizePx) && !Number.isNaN(currentFontSizePx)
        ? currentFontSizePx
        : defaultFontSize;
    return emVal * fontSize;
  }
  if (cssValue.endsWith('px')) {
    const pxCandidateVal = parseFloat(cssValue.slice(0, -2));
    return Number.isFinite(pxCandidateVal) && !Number.isNaN(pxCandidateVal) ? pxCandidateVal : 0;
  }
  if (cssValue.endsWith('%')) {
    const percentageCandidateVal = parseFloat(cssValue.slice(0, -1));
    const fontSize =
      currentFontSizePx && Number.isFinite(currentFontSizePx) && !Number.isNaN(currentFontSizePx)
        ? currentFontSizePx
        : defaultFontSize;
    return Number.isFinite(percentageCandidateVal) && !Number.isNaN(percentageCandidateVal)
      ? (percentageCandidateVal / 100) * fontSize
      : 0;
  }
  return 0;
};
